// PolicyDetail.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PolicyDetail.css";

const PolicyDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pdfUrl} = location.state || {};

  if (!pdfUrl) {
    return <p>Policy not found. Please go back and try again.</p>;
  }

  return (
    <div className="policy-view-container">
      <button onClick={() => navigate(-1)} className="back26-button">
        ←
      </button>

      <div className="pdf-viewer">
        <iframe
          src={pdfUrl}
          width="100%"
          height="600px"
          style={{ border: "none" }}
          title="Policy PDF"
        />
      </div>
    </div>
  );
};

export default PolicyDetail;
